export default function truncateStringWithEllipses(str: string, maxChar: number) {
  return str.length > maxChar ? `${str.substring(0, maxChar)}...` : str;
}
